<template>
    <div class="page-wrapper">
        <div class="page">
            <ul class="page-nav">
                <li><router-link to="/layout/index">首页</router-link></li>
                <!-- <li><a class="a_disabled">协会工作部</a></li> -->
                <li><router-link :to="titleLink">{{ title }}</router-link></li>

            </ul>
            <div class="page-main">
                <ul class="vertical-nav">
                    <li class="rootMenu"><a>{{ title }}</a></li>
                    <li><router-link :to="`/layout/info-branch-introduction?id=${id}`">工作部简介</router-link></li>
                    <li><router-link :to="`/layout/info-branch-responsibilities?id=${id}`">主要职责</router-link></li>

                </ul>
                <div class="page-content">
                    <h3>机构设置</h3>
                    <img class="institutional-structure" :src="imageUrl" />
                    <!-- <img class="institutional-structure" src="@/assets/image/info/institutiona_setup.png" /> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    getXiehuiModel,
} from '@services/indexService.js'
export default {
    name:'',
    data() {
        return {
            id: '',
            title: '',
            imageUrl: '',
            titleLink: '',
        }
    },
    created() {
        this.id = this.$route.query.id;
        this.traverseTitle();
        this.getXiehuiModel();
    },
    methods: {
        handleCurrentChange(pageNum) {

        },
        traverseTitle() {
            if (this.id === '1'){
                this.title = "信息工作部";
                this.titleLink = '/layout/info-branch-introduction?id=1';
            } else if (this.id === '2'){
                this.title = "双招双引工作部";
                this.titleLink = '/layout/info-branch-introduction?id=2';
            } else if (this.id === '3') {
                this.title = "医药卫生工作部";
                this.titleLink = '/layout/info-branch-introduction?id=3';
            } else {
                this.title = "驻京企业工作部";
                this.titleLink = '/layout/info-branch-introduction?id=4';
            }
        },
        getXiehuiModel() {
            let params = {
                id: this.id
            };
            getXiehuiModel(params).then(res => {
                console.log(res);
                if (res.Code == 1) {
                    this.imageUrl = res.Data.WebSite;
                } else {
                    this.imageUrl = '';
                    this.$message.error("机构设置请求失败");
                }
            })
        }
    },
    watch: {
        // 监听路由对象中的变化
        '$route': {
            handler: function(to, from) {
                // 当路由发生变化时会调用这个函数
                // to 和 from 分别代表到达的路由和离开的路由
                this.id = to.query.id + '';
                this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        },
        '$route.query.id': {
            handler: function(toId, fromId){
                this.id = toId;
                this.getXiehuiModel();
                this.traverseTitle();
            },
            // 如果需要在路由变化时立即响应，可以设置immediate为true
            immediate: true
        },
    }
}
</script>

<style scoped>
.page-content {
    padding: 30px;
}
.page-content h3{
    text-align:center;
}
.institutional-structure{
    display: block;
    /*width: 596px;*/
    /*height: 369px;*/
    margin : 0 auto;
    margin-bottom: 20px;
}
.page-content p {
    font-family: 思源黑体 CN;
    font-size: 16px;
    line-height: 28.64px;
    color: #4E5969;
    margin-bottom: 20px;
    width: 100%;
}
.page-content p:nth-of-type(1){
    text-indent: 0;
    margin-bottom: 0;
}
.association-member h4{
    color: #262626;
    font-size: 18px;
}
.association-member p:nth-of-type(1){
    color:#262626;
}
.association-member p:nth-of-type(2){
    color: #86909C;

}
.institution-list,
.member-enterprise-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
}
.institution-item img{
    width: 216px;
    height: 120px;  
}
.institution-item p {
    font-size: 14px;
    text-align:center;
    color: #4E5969;
}
.member-enterprise-item {
    width: 216px;
    height: 68px;
    line-height: 68px;
    text-align: center;
    color: #4E5969;
    font-size: 14px;
    background: #F6F6F6;
}
.a_disabled {
    cursor: not-allowed;
}
</style>